import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Especialidade } from '../especialidade';
import { EspecialidadeService } from '../especialidade.service';

@Component({
  selector: 'app-especialidade-maintenance',
  templateUrl: './especialidade-maintenance.component.html',
  styleUrls: ['./especialidade-maintenance.component.css']
})
export class EspecialidadeMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  especialidade: Especialidade;

  formularioDeEspecialidade: FormGroup;

  tituloCrud: string = '';

  constructor(private especialidadeService: EspecialidadeService,
    private route: ActivatedRoute, private router: Router,
    private formBuilder: FormBuilder) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.especialidade = new Especialidade();

    this.formularioDeEspecialidade = this.formBuilder.group({
      id: 0,
      nome: ['', [Validators.required,
      Validators.minLength(6)]]
    });
  }

  ngOnInit() {
    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Especialidade';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Especialidade';
      }
    } else {
      this.tituloCrud = 'Criar Especialidade';
    }

    if (!this.isNew()) {
      this.especialidadeService.procurarPorId(this.id)
        .subscribe(data => {
          // console.log(data)

          this.especialidade = data;

          this.formularioDeEspecialidade.setValue(this.especialidade);

          if (this.isUpdate == 'N') {
            this.formularioDeEspecialidade.disable();
          }
        }, error => {
          console.log(error);
        });
    } else {
      this.formularioDeEspecialidade.setValue({
        id: 0,
        nome: ''
      });
    }
  }

  save() {

    this.especialidade.nome = this.formControl.nome.value;

    if (this.isNew()) {
      this.especialidadeService
        .criar(this.especialidade).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.especialidadeService.atualizar(this.especialidade, this.id)
        .subscribe(data => {
          // console.log(data);

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/especialidades']);
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioDeEspecialidade.controls;
  }
}
